var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.433674,2.0573338 C9.54595638,1.97004547 7.73664387,0.804719604 6.94518892,0.151212681 C6.71861282,-0.036341673 6.37059471,-0.0523415705 6.1336093,0.119568439 C5.30138453,0.719386817 3.28145688,1.9492456 0.555951124,2.0543116 C0.265704713,2.06746707 0.0219532437,2.30266556 0.0158811431,2.59955255 C-0.00788679379,3.74336744 -0.0349510139,6.48646097 0.177572509,8.69782457 C0.637143784,11.5171843 4.72644334,14.8469407 6.07549062,15.8672009 C6.30952673,16.0442664 6.70091699,16.0442664 6.9349531,15.8672009 C8.28400037,14.8469407 12.3736469,11.5171843 12.8332182,8.69782457 C13.0453947,6.48663875 13.0060128,3.74336744 12.9761728,2.59955255 C12.9685393,2.30266556 12.7239204,2.06586708 12.433674,2.0573338 Z M8.26266128,7.53534314 L8.67816645,10.0210161 L6.5000172,8.84786806 L4.32186795,10.0211939 L4.73737312,7.53552091 L2.97403509,5.77410998 L5.41102932,5.41197897 L6.5000172,3.14852681 L7.58900508,5.41162341 L10.0256523,5.77375443 L8.26266128,7.53534314 Z",
    id: "tru-permission"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermission);
export default ForwardRef;